import React, { Component } from 'react'
import { Header } from 'semantic-ui-react'
import { translate } from 'react-i18next'

class ViewTitle extends Component {

  render() {
    const { t } = this.props;
    if (this.props.title === null) {
      return null;
    }
    let myTitles = this.props.title.map(title => t(title));
    return (
      <Header as="h1">{myTitles.join(t("Separators.vertical"))}</Header>
    );
  }
}

export default translate()(ViewTitle);
